import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertBmpToJpg() {
  return <ImageConverterTemplate sourceFormat="BMP" targetFormat="JPG" acceptTypes=".bmp,image/bmp" slug="convert-bmp-to-jpg" gradientColors="from-orange-500 to-amber-600" accentColor="orange" showQualitySlider={true} />;
}
